module.exports = __webpack_public_path__ + "static/4661ad87f87070b115dee666c48237d2cdc3297a58de21290011d4d3719d82c3-bbe819d67ce231889707e1d5611edab4.jpeg";